import { tryFetch, HttpMethod, type HttpResponse } from '@/modules/services/http'
import type { CacheSectionResponse } from '../models/cache.model'
import type { CacheUpdateRequest } from './cache.requests'

const BASE_URL = import.meta.env.VITE_MAIN_BASE_URL

const checkStatus = async (
  body: CacheUpdateRequest,
): Promise<HttpResponse<CacheSectionResponse, null>> =>
  await tryFetch(HttpMethod.Post, BASE_URL, ['cache', 'check-status'], {
    view: true,
    body,
  })

export const cacheApi = {
  checkStatus,
}
